import { AdminDashboard } from "apiEndPoints";
import APIrequest from "services/axios";
import { logger } from "utils";

export const DashboardService = {
  getDashboardService: async () => {
    try {
      const payload = {
        ...AdminDashboard.getAdminDashboard,
      };

      return await APIrequest(payload);
    } catch (err) {
      logger(err);
      throw err;
    }
  },
  getDashboardLineGraphService: async () => {
    try {
      const payload = {
        ...AdminDashboard.getAdminDashboardLineGraph,
      };

      return await APIrequest(payload);
    } catch (err) {
      logger(err);
      throw err;
    }
  },
  getDashboardPieChartService: async () => {
    try {
      const payload = {
        ...AdminDashboard.getAdminDashboardPieChart,
      };
      return await APIrequest(payload);
    } catch (err) {
      logger(err);
      throw err;
    }
  },
};
